// erp.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { environment } from '../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { StatementOfAccountProperties, SearchStatementOfAccountProperties, PdfStatementOfAccountProperties, ERPCustomerStatementReq } from '../Models/StatementOfAccountProperties';

@Injectable({
  providedIn: 'root'
})
export class StatementOfAccountService {
  ////private apiUrl = 'http://localhost:51401/api'; // Adjust the ERP API URL
  //public apiUrl = this.getERPUrl(); // Adjust the ERP API URL

  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl;
  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public showLoader: BehaviorSubject<boolean> = new BehaviorSubject(false);
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }



  
  getErpJournalLedger(searchObj: ERPCustomerStatementReq): Observable<StatementOfAccountProperties[]> {
    return this.http.post<StatementOfAccountProperties[]>(this.baseUrl + '/ERPBackOffice/GetERPLeadger', searchObj, this.httpOptions).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }));
  }

}



